import { graphql, readInlineData } from "react-relay";

import { checkSchemaNodeHasYoutubeVideo } from "scmp-app/components/schema-render/common/iframe/helpers";
import type { helpersIsArticleVideoAsHeroArticle$key } from "scmp-app/queries/__generated__/helpersIsArticleVideoAsHeroArticle.graphql";

export const isArticleVideoAsHero = (reference: helpersIsArticleVideoAsHeroArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersIsArticleVideoAsHeroArticle on Article @inline {
        multimediaEmbed {
          json
        }
      }
    `,
    reference,
  );

  return (
    article?.multimediaEmbed?.json?.some(node => checkSchemaNodeHasYoutubeVideo(node)) ?? false
  );
};

export type ArticleLeadVideo = {
  duration?: string;
  youtubeId: string;
};

export const getArticleLeadVideo = (
  multimediaEmbedJson: null | Schema | undefined,
): ArticleLeadVideo | undefined => {
  const findYoutubeNode = (nodes: SchemaNode[]): SchemaNode | undefined => {
    for (const node of nodes) {
      if (node.attribs?.["data-youtube-id"]) return node;
      const childNode = node.children ? findYoutubeNode(node.children) : undefined;
      if (childNode) return childNode;
    }
    return undefined;
  };

  if (!multimediaEmbedJson?.some(node => checkSchemaNodeHasYoutubeVideo(node))) return;
  const youtubeNode = findYoutubeNode(multimediaEmbedJson);
  const youtubeId = youtubeNode?.attribs?.["data-youtube-id"];
  if (!youtubeId) return;

  return {
    duration: youtubeNode?.attribs?.["data-duration"],
    youtubeId,
  };
};
